import {
  SESSION_RUN,
  SESSION_STOP,
  SESSION_CREATED,
  SESSION_DOWNLOAD,
  LEARN_MODAL_SHOW,
  TUTORIAL_FETCHED,
  TUTORIALSTATE_AND_SOLUTION_FETCH_FINISHED
} from '../definitions/events.ts';

export default function ($store, $root) {
  $root.$on(TUTORIAL_FETCHED, async (tutorial) => {
    // fetch tutorialState
    try {
      const fetchTutorialStateByUserPromise = await $root.$store
        .dispatch(
          'workspace/session/fetchTutorialStateByUser',
          tutorial.tutorialId
        )
        .then((res) => {
          if (res.totalCount) {
            $root.$store.dispatch(
              'workspace/session/syncCurrentPageWithTutorialState'
            );
            $root.$store.dispatch(
              'workspace/session/syncAppJsonWithTutorialState'
            );
          }
        });

      // fetch user solutions

      const fetchSolutionsByUserPromise = $root.$store.dispatch(
        'workspace/session/fetchSolutionsByUser',
        tutorial.tutorialId
      );
      console.log('fetch::tutorialState');
      await fetchTutorialStateByUserPromise;
      console.log('fetch::userSolutions');
      await fetchSolutionsByUserPromise;
      console.log('fetched');
    } catch (err) {
      console.log('fetch errors:', err);
    }

    $root.$emit(TUTORIALSTATE_AND_SOLUTION_FETCH_FINISHED);
  });

  $root.$on(TUTORIALSTATE_AND_SOLUTION_FETCH_FINISHED, () => {
    if (!$root.$store.getters['workspace/session/showingDesignPage']) {
      // if there is no screen page
      $root.$store.dispatch('workspace/session/createNewScreenPage', 1);
    }
  });

  $root.$on(SESSION_RUN, () => {
    $store.dispatch('workspace/session/saveScreenPageCode');
    console.log('Session::run', '1: set run mode');
    $store.commit('workspace/session/setRunMode');
  });

  $root.$on(SESSION_STOP, () => {
    console.log('Session::stop', '1: set edit mode');
    $store.commit('workspace/session/setEditMode');
  });

  $root.$on(SESSION_CREATED, async () => {
    console.log('fetch::userState');
    try {
      const data = await $store.dispatch(
        'workspace/session/fetchUserStateByUser'
      );
      // @todo refactor use vuex.

      if (!data || !data.params || !JSON.parse(data.params).LearnModalOpened) {
        $root.$emit(LEARN_MODAL_SHOW);
      }
    } catch (err) {
      $root.$emit(LEARN_MODAL_SHOW);
    }
  });

  // run download stats
  $root.$on(SESSION_RUN, () =>
    $store.dispatch('workspace/session/addStat', 'RUN')
  );

  $root.$on(SESSION_DOWNLOAD, () =>
    $store.dispatch('workspace/session/addStat', 'DOWNLOAD')
  );
}
